module.exports = __webpack_public_path__ + "d8af95b0a67e44ff676992a7ec5feb8b.png";